import React from 'react';

export default function About({ lang }) {
  const fr = lang === 'fr';
  const values = [
    { title:fr?'Qualité certifiée CE & ISO 13485':'CE & ISO 13485 certified quality', desc:fr?'Produits homologués par le Ministère de la Santé marocain, conformes aux normes CE et ISO 13485.':'Products approved by the Moroccan Ministry of Health, compliant with CE and ISO 13485 standards.' },
    { title:fr?'Livraison 24–48h partout au Maroc':'24–48h delivery across Morocco', desc:fr?'Réseau logistique couvrant Casablanca, Rabat, Marrakech, Fès, Tanger, Agadir et toutes les régions.':'Logistics network covering Casablanca, Rabat, Marrakech, Fes, Tangier, Agadir and all regions.' },
    { title:fr?'Traçabilité totale lot par lot':'Full batch-by-batch traceability', desc:fr?'Suivi complet avec numéro de lot et certificat de conformité pour chaque dispositif médical.':'Complete tracking with batch number and compliance certificate for each medical device.' },
    { title:fr?'Équipe spécialisée 6j/7':'Specialized team 6 days/7', desc:fr?'Ingénieurs biomédicaux disponibles 6j/7 pour vos appels d\'offres et commandes récurrentes.':'Biomedical engineers available 6 days a week for tenders and recurring orders.' },
  ];
  const team = [
    { initials:'AD', name:'Adil EL.', role:fr?'Directeur général':'General Manager', bg:'#E6F1FB', color:'#0B4F8A' },
    { initials:'HL', name:'Hazma LA.', role:fr?'Directeur financier':'CFO', bg:'#E1F5EE', color:'#085041' },
    { initials:'SA', name:'Sara A.', role:fr?'Responsable commercial':'Sales Manager', bg:'#FAEEDA', color:'#854F0B' },
  ];
  const partners = ['CHU Ibn Rochd — Casablanca','Hôpital Cheikh Khalifa','Clinique Al Wafaa','CHU Hassan II — Fès','Clinique du Palmier','Centre Oncologie Ibn Rochd','Hôpital Moulay Youssef','Polyclinique Atlas'];

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: fr ? 'À propos de LOMED MEDICARE' : 'About LOMED MEDICARE',
    description: fr ? 'LOMED MEDICARE est une société marocaine spécialisée dans la distribution de dispositifs médicaux certifiés CE. Fondée en 2026 à Casablanca.' : 'LOMED MEDICARE is a Moroccan company specializing in CE-certified medical device distribution. Founded in 2026 in Casablanca.',
    url: 'https://lomedmedicare.com/about',
    about: {
      '@type': 'Organization',
      name: 'LOMED MEDICARE',
      foundingDate: '2026',
      foundingLocation: 'Casablanca, Maroc',
      numberOfEmployees: { '@type': 'QuantitativeValue', value: 10 },
      knowsAbout: ['Dispositifs médicaux', 'Distribution médicale', 'Centrale achat', 'Pharmacie clinique'],
    },
  };

  return (
    <div style={{ maxWidth:960, margin:'0 auto', padding:'1rem' }}>

      
        <title>{fr
          ? 'À propos — LOMED MEDICARE | Distributeur Médical Casablanca Maroc'
          : 'About — LOMED MEDICARE | Medical Distributor Casablanca Morocco'}</title>
        <meta name="description" content={fr
          ? "LOMED MEDICARE, société marocaine fondée en 2026 à Casablanca. Distributeur agréé de dispositifs médicaux certifiés CE. 120+ établissements partenaires au Maroc."
          : "LOMED MEDICARE, Moroccan company founded in 2026 in Casablanca. Licensed distributor of CE-certified medical devices. 120+ partner institutions in Morocco."} />
        <meta name="keywords" content={fr
          ? 'LOMED MEDICARE entreprise, distributeur médical Casablanca, société distribution médicale Maroc, équipe médicale Maroc'
          : 'LOMED MEDICARE company, medical distributor Casablanca, medical distribution company Morocco'} />
        <link rel="canonical" href="https://lomedmedicare.com/about" />
        <meta property="og:title" content={fr ? 'À propos — LOMED MEDICARE Casablanca' : 'About — LOMED MEDICARE Casablanca'} />
        <meta property="og:description" content={fr ? "Distributeur agréé de dispositifs médicaux certifiés CE. Fondé à Casablanca en 2026." : "Licensed distributor of CE-certified medical devices. Founded in Casablanca in 2026."} />
        <meta property="og:url" content="https://lomedmedicare.com/about" />
        <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
    

      {/* Hero */}
      <div style={{ position:'relative', borderRadius:16, overflow:'hidden', marginBottom:'1.5rem', height:180 }}>
        <img src="https://images.unsplash.com/photo-1504813184591-01572f98c85f?w=1200&q=80&fit=crop" alt="Équipe LOMED MEDICARE Casablanca Maroc" loading="eager" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(90deg,rgba(11,79,138,0.9),rgba(11,79,138,0.4))', display:'flex', alignItems:'center', padding:'1.5rem' }}>
          <div>
            <h1 style={{ fontSize:'clamp(18px,4vw,24px)', fontWeight:700, color:'#fff', marginBottom:6 }}>LOMED MEDICARE</h1>
            <p style={{ fontSize:13, color:'rgba(255,255,255,0.85)', maxWidth:360 }}>{fr?'Distributeur médical agréé — fondé à Casablanca, Maroc en 2026':'Licensed medical distributor — founded in Casablanca, Morocco in 2026'}</p>
          </div>
        </div>
      </div>

      {/* Description */}
      <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1.5rem', marginBottom:'1.5rem', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
        <p style={{ fontSize:14, lineHeight:1.85, color:'#475569' }}>
          <strong style={{ color:'#1a2535' }}>LOMED MEDICARE</strong> {fr
            ? 'est une société marocaine fondée en 2026, spécialisée dans la distribution de dispositifs médicaux certifiés CE aux établissements de santé publics et privés du Maroc. Notre centrale d\'achat groupée permet aux cliniques et hôpitaux de réduire leurs coûts de 15 à 30%. Notre logiciel StockMed révolutionne la gestion de stock et de pharmacie clinique.'
            : 'is a Moroccan company founded in 2026, specializing in the distribution of CE-certified medical devices to public and private healthcare institutions across Morocco. Our group purchasing center allows clinics and hospitals to reduce costs by 15 to 30%. Our StockMed software revolutionizes stock and clinical pharmacy management.'}
        </p>
      </div>

      {/* Stats */}
      <section aria-label={fr ? 'Chiffres clés LOMED MEDICARE' : 'LOMED MEDICARE key figures'}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(100px,1fr))', gap:10, marginBottom:'1.5rem' }}>
          {[{n:'2026',l:fr?'Fondée':'Founded'},{n:'120+',l:fr?'Établissements':'Institutions'},{n:'500+',l:fr?'Références':'References'},{n:'48h',l:fr?'Livraison':'Delivery'}].map(s=>(
            <div key={s.l} style={{ background:'#E6F1FB', border:'1px solid #B5D4F4', borderRadius:10, padding:'14px 8px', textAlign:'center' }}>
              <div style={{ fontSize:20, fontWeight:700, color:'#0B4F8A' }}>{s.n}</div>
              <div style={{ fontSize:11, color:'#185FA5', marginTop:3 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Values */}
      <section aria-label={fr ? 'Nos valeurs' : 'Our values'}>
        <h2 style={{ fontSize:16, fontWeight:700, marginBottom:12 }}>{fr?'Nos valeurs':'Our values'}</h2>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:12, marginBottom:'1.5rem' }}>
          {values.map(v=>(
            <div key={v.title} style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1rem', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
              <div style={{ fontSize:13, fontWeight:600, color:'#0B4F8A', marginBottom:5 }}>{v.title}</div>
              <div style={{ fontSize:12, color:'#64748b', lineHeight:1.65 }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section aria-label={fr ? 'Notre équipe' : 'Our team'}>
        <h2 style={{ fontSize:16, fontWeight:700, marginBottom:12 }}>{fr?'Notre équipe':'Our team'}</h2>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:12, marginBottom:'1.5rem' }}>
          {team.map(m=>(
            <div key={m.name} style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1rem', display:'flex', alignItems:'center', gap:12, boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
              <div style={{ width:44, height:44, borderRadius:'50%', background:m.bg, color:m.color, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:600, fontSize:14, flexShrink:0 }}>{m.initials}</div>
              <div>
                <div style={{ fontSize:13, fontWeight:600 }}>{m.name}</div>
                <div style={{ fontSize:12, color:'#64748b' }}>{m.role}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Partners */}
      <section aria-label={fr ? 'Établissements partenaires' : 'Partner institutions'}>
        <h2 style={{ fontSize:16, fontWeight:700, marginBottom:12 }}>{fr?'Établissements partenaires':'Partner institutions'}</h2>
        <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginBottom:'1.5rem' }}>
          {partners.map(p=>(
            <span key={p} style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:8, padding:'6px 12px', fontSize:12, color:'#64748b' }}>{p}</span>
          ))}
          <span style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:8, padding:'6px 12px', fontSize:12, color:'#64748b' }}>{fr?'+ 113 établissements':'+ 113 institutions'}</span>
        </div>
      </section>

      {/* Cert */}
      <div style={{ background:'#FAEEDA', border:'1px solid #EF9F27', borderRadius:12, padding:'1rem', display:'flex', alignItems:'center', gap:12 }}>
        <div style={{ width:40, height:40, background:'#fff', borderRadius:9, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <svg viewBox="0 0 24 24" style={{ width:20, height:20, fill:'none', stroke:'#BA7517', strokeWidth:2 }}>
            <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
          </svg>
        </div>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:'#BA7517' }}>{fr?'Certifié Ministère de la Santé — Maroc':'Certified Ministry of Health — Morocco'}</div>
          <div style={{ fontSize:12, color:'#854F0B', marginTop:2 }}>{fr?'Tous nos dispositifs médicaux respectent les normes CE et ISO 13485':'All our medical devices comply with CE and ISO 13485 standards'}</div>
        </div>
      </div>
    </div>
  );
}

